<template>
    <div class="row">
        <div
            class="col-sm-6 text-center borderLine"
            v-show="showDocuments"
            v-for="(document, index) in documents"
            :key="index"
        >
            <br>
            <input
                type="file"
                id="file" style="display: none"
                @change="onFileSelected"
            >
            <h4 class="text-capitalize height-50"> 
                {{document.name}}
            </h4><br>
            <base-progress
                v-if="loadPercent.show && (selectedFileName == document.filename)"
                :type="loadPercent.type"
                :height="10"
                :value="loadPercent.value"
                :striped="true"
                :animated="loadPercent.animated"
            >
            </base-progress>

            <span v-if="! loadPercent.show">
                <base-button
                    size="sm" type="primary"
                    v-if="! document.hasFile &&
                            ((selectedFileName != document.filename))"
                    @click="selectFile(document.filename)"
                    :disabled="(lock && ! type) || (type && (type != 'upgrade'))"
                >
                    <i class="fa fa-hand-pointer"></i> Select File
                </base-button>

                <base-button
                    tag="a" type="primary"
                    size="sm"
                    v-if="document.hasFile && ! showUploadButton ||
                        ((selectedFileName != document.filename) && document.hasFile)"
                    class="active" role="button"
                    aria-pressed="true"
                    @click="viewDocument('internship_performance/' + document.filename)"
                >
                    <i class="fa fa-eye"></i> View File
                </base-button>

                <base-button
                    size="sm" type="warning"
                    v-if="document.hasFile && ! showUploadButton ||
                        ((selectedFileName != document.filename) && document.hasFile)"
                    @click="selectFile(document.filename)"
                    :disabled="(lock && ! type) || (type && (type != 'upgrade'))"
                >
                    <i class="fa fa-pen"></i> Change File
                </base-button>
                <base-button
                    size="sm" type="success"
                    v-if="showUploadButton && (selectedFileName == document.filename) && ! loadPercent.show"
                    @click="onUpload()"
                    :disabled="(lock && ! type) || (type && (type != 'upgrade'))"
                >
                    <i class="fa fa-upload"></i> Upload File
                </base-button>
                <base-button
                    size="sm" type="danger"
                    v-if="showUploadButton && (selectedFileName == document.filename) && ! loadPercent.show"
                    @click="removeFile()"
                >
                    <i class="fa fa-times"></i> Cancel
                </base-button>
            </span>
            <br><br>
        </div>

        <div class="col-sm-12 text-center">
            <base-alert type="danger" dismissible v-if='showErrorStatus'>
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </base-alert>
        </div>
    </div>

</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import swal from 'sweetalert';// import sweet alert

    export default {
        name: 'InternshipDocument',
        props: ["documents", "id", "loadInternship", "type"],
        data() {
            return {
                // documents: {},
                showDocuments: true,
                isloading: false,
                showErrorStatus: false,
                errorMsg: null,
                showUploadButton: false,
                savedEvent: null,
                uploadedFile: {
                    'name' : null,
                    'file' : null,
                    'id': this.id
                },
                selectedFileName: null,
                loadPercent: {
                    type: 'warning',
                    value: 10,
                    animated: true,
                    show: false
                },
                fileName: null
            }
        },
        computed: {
            ...mapGetters(['lock']),
        },
        methods: {
            ...mapActions(['uploadInternshipDocuments', 'viewUserDocument']),
            selectFile(name) {// eslint-disable-next-line
                $('#file').val('');
                this.selectedFileName = null;
                this.showUploadButton = false;// eslint-disable-next-line
                $('#file').click();
                this.fileName = name;// add file new name

            },
            removeFile() {// eslint-disable-next-line
                $('#file').val('');
                this.selectedFileName = null;
                this.uploadedFile.name = null;
                this.uploadedFile.file = null;
                this.showUploadButton = false;
                this.savedEvent = null;
            },
            onFileSelected(event) {
                this.savedEvent = event;
                let status =  this.validateFile(event.target.files[0]);
                if(status) {
                    this.uploadedFile.name = this.fileName;// add file new name
                    this.selectedFileName = this.fileName;
                    this.fileName = null;
                }
                status ? this.showUploadButton = true : false;
                return status;
            },
            validateFile(file) {// check for valid file
                if(!file) {// update seleted file name
                    this.uploadedFile.name = null;
                    this.selectedFileName = null;
                }
                var fileExt = file.type.split('/').pop();
                let fileSize = file.size;
                if(fileExt == 'pdf' && fileSize <= 800000) {// for valid file and size
                    return true;
                } else if(fileExt != 'pdf') {// invalid file
                    this.uploadedFile.name = null;
                    this.selectedFileName = null;
                    swal("Invalid File!", "Only PDF files are accepted", "warning");
                    return false;
                } else if(fileSize > 800000) {// big file
                    this.uploadedFile.name = null;
                    this.selectedFileName = null;
                    swal("File is too large!", "File should not be more than 800KB", "warning");
                    return false;
                }
            },
            onUpload() {// upload document
                this.loadPercent.show = true;
                this.loadPercent.value = 10;
                this.loadPercent.type = 'warning';
                this.$store.state.user.uploadProgress = null;
                let event = this.savedEvent;// get store file event
                var fileReader = new FileReader();
                fileReader.readAsDataURL(event.target.files[0]);
                fileReader.onload = (event) => {// convert file to binary
                    this.uploadedFile.file = event.target.result;
                    this.uploadedFile.id = this.id;//get user Id
                    this.uploadInternshipDocuments(this.uploadedFile).then((res) => {
                        // console.log(this.$store.state.internship.uploadDocProgress, this.loadPercent.show);
                        this.uploadPercent(this.$store.state.internship.uploadDocProgress);// show load progress
                        var self = this;
                        self.showUploadButton = false;
                        if(res.status) {
                            setTimeout(function() {
                                self.selectedFileName = null;
                                self.loadPercent.show = false;
                                self.loadInternship();// refresh page
                            }, 3000);
                        } else {
                            swal("Error Occurred!", "An error occurred while uploading, try again", "warning");
                            setTimeout(function() {
                                self.selectedFileName = null;
                                self.loadPercent.show = false;
                                self.loadInternship();// refresh page
                            }, 2000);
                        }
                    }).
                    catch(err => {
                        swal(err.message+"!", "Reduce file size and try again...", "warning");
                        this.loadPercent.show = false;
                        this.showUploadButton = false;
                        this.selectedFileName = null;
                        this.loadInternship();// refresh page
                    });
                }
            },
            uploadPercent(percent) {// update upload progress percent
                this.loadPercent.value = percent;
                this.loadPercent.type = percent > 60 ? 'success' : 'warning';
            },
            async viewDocument(filename) {// view user document
                this.viewUserDocument(filename).then(() => {
                    // document will be opened in new tab
                }).
                catch(err => {
                    swal.fire(err.message+"!", "An error occurred while fetching document, try again...", "warning");
                });
            }
        }
    }
</script>

<style scoped>
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>
